// frontend/src/pages/VerifyReminder.tsx
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import api from "../lib/axios"
import { Button } from "../components/ui/button"

export default function VerifyReminder() {
  const location = useLocation() as any
  const [email, setEmail] = useState<string>(location?.state?.email || "")
  const [cooldown, setCooldown] = useState<number>(0)
  const [msg, setMsg] = useState<string>("Looks like you haven’t verified your email yet.")

  useEffect(() => {
    let t: any
    if (cooldown > 0) {
      t = setTimeout(() => setCooldown(cooldown - 1), 1000)
    }
    return () => clearTimeout(t)
  }, [cooldown])

  const resend = async () => {
    if (!email) { setMsg("Enter your email to resend."); return }
    const res = await api.post("/auth/resend-verification", { email })
    const wait = res?.data?.resend_allowed_in ?? 0
    setCooldown(wait)
    setMsg("If that email exists, we sent a new link.")
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-4">
        <h1 className="text-2xl font-semibold">Verify your email</h1>
        <p>{msg}</p>
        {!email && (
          <input
            className="border px-3 py-2 w-full rounded"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value.trim().toLowerCase())}
          />
        )}
        <Button onClick={resend} disabled={cooldown > 0} className="w-full">
          {cooldown > 0 ? `Resend available in ${cooldown}s` : "Resend verification email"}
        </Button>
        <p className="text-sm text-gray-500">Check your spam folder just in case.</p>
      </div>
    </div>
  )
}
